export default "__VITE_ASSET__B7D85ZKJ__"